import { buildPropertyWithFilteredOptions, getActiveRules, getParsedPropertyValueAsArray, getValidation, someValueHasNoRule } from '../conditionalPropertyOptionsRules/utils';
export const getActivePropertyWithFilteredOptions = ({
  conditionalPropertyOptionsRulesForProperty,
  controllingFieldCurrentValue,
  controllingFieldProperty,
  originalProperty,
  value
}) => {
  const defaultReturn = {
    property: originalProperty,
    error: false,
    validationMessage: null
  };

  // if the controlling property has been deleted, we don't filter options
  if (!controllingFieldProperty) {
    return defaultReturn;
  }

  // no CPO logic can be set for these two controlling property values
  if (controllingFieldCurrentValue === undefined || controllingFieldCurrentValue === null) {
    return defaultReturn;
  }

  // starting with an array helps in case of multi-enums
  // we split values for multi-enum so that we can use same logic for single select and multi-enum
  const controllingFieldCurrentValues = getParsedPropertyValueAsArray(controllingFieldProperty, controllingFieldCurrentValue);

  // if there is at-least one value with no rule for it, then we should all options - no rule means ALL options in dependent field
  if (someValueHasNoRule(controllingFieldCurrentValues, conditionalPropertyOptionsRulesForProperty)) {
    return defaultReturn;
  }
  const activeConditionalPropertyOptionsRules = getActiveRules(controllingFieldCurrentValues, conditionalPropertyOptionsRulesForProperty);
  const propertyForActiveRules = buildPropertyWithFilteredOptions(originalProperty, activeConditionalPropertyOptionsRules);
  const {
    error,
    validationMessage
  } = getValidation({
    originalProperty,
    propertyForActiveRules,
    value,
    controllingFieldLabel: controllingFieldProperty.label
  });
  return {
    property: propertyForActiveRules,
    error,
    validationMessage
  };
};